import { Component, EventEmitter, Output } from '@angular/core';
import { BaseGridComponent } from '@m4u-angular/base/component/BaseGridComponent';
import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { BaseState, CredentialActivityStatus } from '@m4u-angular/base/entities/BaseEntities';

@Component({
    providers: ServiceBagServices,
    selector: 'app-request-history-grid',
    templateUrl: './request-history-grid.component.html',
    styleUrls: ['./request-history-grid.component.scss']
})
export class RequestHistoryGridComponent extends BaseGridComponent<CredentialActivityStatus, BaseState> {
    @Output() OnRefresh = new EventEmitter<void>();

    constructor(A: ServiceBagService) {
        super(A, 'RequestHistoryGridComponent', CredentialActivityStatus, BaseState);
    }

    OnRowClick(e) {
        if (e.data.EntryID) { this.Navigate(['/pages/general/request-history', e.data.EntryID]); }
    }

    GetStatusColor(isSuccess: boolean) {
        return isSuccess ? 'green-cyan' : 'cinnabar';
    }

    OnToolbarPreparing = (e) => {
        e.toolbarOptions.items.unshift({
            location: 'after',
            widget: 'dxButton',
            isCustom: true,
            options: {
                icon: 'refresh',
                onClick: () => {
                    this.OnRefresh.emit();
                }
            }
        });
    }
}
